import { PeopleTagsContext } from "./PeopleTagsContext";
import { useContext } from "react";

export const usePeopleTagsContext = () => {
  const context = useContext(PeopleTagsContext);

  if (!context) {
    throw new Error(
      "usePeopleTagsContext must be used within a PeopleTagsContextProvider",
    );
  }

  return context;
};
